import { render } from "./TalkRoomNice.vue?vue&type=template&id=4e0e3bf2&ts=true"
import script from "./TalkRoomNice.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkRoomNice.vue?vue&type=script&lang=ts&setup=true"

import "./TalkRoomNice.vue?vue&type=style&index=0&id=4e0e3bf2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/talkRoom/TalkRoomNice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e0e3bf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e0e3bf2', __exports__)) {
    api.reload('4e0e3bf2', __exports__)
  }
  
  module.hot.accept("./TalkRoomNice.vue?vue&type=template&id=4e0e3bf2&ts=true", () => {
    api.rerender('4e0e3bf2', render)
  })

}


export default __exports__